import { Button, Stack, Typography } from '@mui/material'
import { formatNumber } from '../../common/FormatNumber'
import type { IProjectAuthorShort } from '../../api/types/projects'
import { IconLike } from '../../icons/IconLike'
import { IconLikeFilled } from '../../icons/IconLikeFilled'
import { COLORS } from '../../styles/variables'
import modalEmitter from '../ModalComponent/modalEmitter'
import { SocialOrderLikesModalBody } from '../Modals/SocialOrderLikesModalBody'
import { StackedAvatars } from '../ui-kit/StackedAvatars'

type Props = {
  socialOrderId: number
  isLiked: boolean
  likesCount: number
  likesPreview?: IProjectAuthorShort[] | null
  onToggleLike: () => void
  loading?: boolean
  compact?: boolean
}

export const SocialOrderLikeControl = ({
  socialOrderId,
  isLiked,
  likesCount,
  likesPreview,
  onToggleLike,
  loading = false,
  compact = false,
}: Props) => {
  const openLikesModal = () => {
    if (likesCount <= 0) return
    modalEmitter.emitOpenModal({
      dialog: {
        title: 'Лайки',
        body: <SocialOrderLikesModalBody socialOrderId={socialOrderId} />,
        modalToCentrPosition: true,
      },
    })
  }

  const buttonSx = {
    minWidth: compact ? 32 : 44,
    width: compact ? 32 : undefined,
    height: compact ? 32 : undefined,
    maxHeight: 32,
    p: compact ? 0 : undefined,
    ...(isLiked
      ? {
          backgroundColor: COLORS.CATSKILL_WHITE,
          color: COLORS.BLACK,
          '&:hover': { backgroundColor: COLORS.LINK_WATER },
          '@media (hover: none)': {
            '&:hover': { backgroundColor: COLORS.CATSKILL_WHITE },
          },
        }
      : {}),
  }

  if (compact) {
    return (
      <Stack direction="row" alignItems="center" gap={0.5}>
        <Button
          variant="contained"
          color="secondary"
          onClick={onToggleLike}
          disabled={loading}
          sx={buttonSx}
        >
          {isLiked ? <IconLikeFilled fontSize="small" /> : <IconLike fontSize="small" />}
        </Button>
        <Typography
          variant="black-14-medium"
          onClick={openLikesModal}
          sx={{ cursor: likesCount > 0 ? 'pointer' : 'default', userSelect: 'none' }}
        >
          {formatNumber(likesCount)}
        </Typography>
      </Stack>
    )
  }

  return (
    <Stack direction="row" alignItems="center" gap={1.5}>
      <Button
        variant="contained"
        color="secondary"
        onClick={onToggleLike}
        disabled={loading}
        sx={buttonSx}
      >
        {isLiked ? <IconLikeFilled fontSize="small" /> : <IconLike fontSize="small" />}
      </Button>

      <Stack
        direction="row"
        alignItems="center"
        gap={1}
        onClick={openLikesModal}
        sx={{ cursor: likesCount > 0 ? 'pointer' : 'default' }}
      >
        <StackedAvatars users={likesPreview ?? []} max={3} size={24} overlap={8} />
        <Typography variant="black-14-medium">{formatNumber(likesCount)}</Typography>
      </Stack>
    </Stack>
  )
}
